import { Box, CircularProgress, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import BorderStack from 'components/@common/BorderStack';

const GeneratingTickets = () => {
  return (
    <BorderStack sx={{ py: 3 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 1,
        }}
      >
        <Typography
          variant="small"
          sx={{
            fontWeight: 'bold',
            flex: '1',
          }}
        >
          <FormattedMessage id="account.tickets.generating.title" />
        </Typography>
        <CircularProgress size={24} />
      </Box>
      <Typography variant="small">
        <FormattedMessage id="account.tickets.generating.description" />
      </Typography>
    </BorderStack>
  );
};

export default GeneratingTickets;
